import React, { useState, useEffect } from "react";
import { post } from "../utils/api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CarouselSection from "./cms/CarouselSection";
import GroupSection from "./cms/GroupSection";
import GridSection from "./cms/GridSection";

const HomepageCMS = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [groups, setGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(true);

  const refreshGroups = async () => {
    setGroupsLoading(true);
    try {
      const res = await post("/cms/group/list", {});
      if (res.status) setGroups(res.data || []);
    } catch {
      // silent — GridSection still works with stale groups
    } finally {
      setGroupsLoading(false);
    }
  };

  useEffect(() => {
    refreshGroups();
  }, []);

  if (user?.role !== "Admin") return null;

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h2 className="text-primary-black text-[28px] font-semibold">Homepage CMS</h2>
      <p className="text-[14px] mb-6">
        <span className="font-bold">Content</span> /{" "}
        <span className="font-regular">Homepage CMS</span>
      </p>

      <CarouselSection />
      <GroupSection onSaved={refreshGroups} />
      <GridSection groups={groups} groupsLoading={groupsLoading} />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default HomepageCMS;
